Drupal.behaviors.customEuCookieComplianceBehaviour = {
  attach: function () {
    // Callback function to be executed when the target node or its children are modified
    const mutationCallback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
          // Check if the added nodes include #sliding-popup
          const euCookieCompliance = document.querySelector("#sliding-popup");
          if (euCookieCompliance) {
            // #sliding-popup is now in the DOM, you can interact with it here

            // Move the euCookieCompliance to the top of the body
            document.body.prepend(euCookieCompliance);

            // You can also disconnect the observer if you only need to detect the addition once
            observer.disconnect();
          }
        }
      }
    };

    // Select the target node
    const targetNode = document.body; // You can choose a more specific target if necessary

    // Options for the observer (all childList mutations)
    const observerConfig = { childList: true };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(mutationCallback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, observerConfig);
  },
};
